import {
  COLOR_TYPE,
  colorInput,
  LOGO_TYPE, logoInput,
  PERSONALIZATION_INPUT_TYPE,
} from '../themeUtils';
import React from 'react';
import ColorInput from '../inputs/ColorInput';
import SelectInput from '../inputs/SelectInput';
import TextInput from '../inputs/TextInput';
import PaletteInput from '../inputs/PaletteInput';
import LogoInput from '../inputs/LogoInput';

const InputItemsSubSection = ({selectedOption, setUploadedLogo, preview, setPreview, setHasRemovedLogo, hasRemovedLogo, disabled, type }) => {
  if (type === COLOR_TYPE && selectedOption === COLOR_TYPE.PALETTE){
    return (
      <>
        {colorInput.palette.map((item) => { return (<InputItem inputItem={item} disabled={disabled}/>)})}
      </>
    )
  }else if(type === COLOR_TYPE && selectedOption === COLOR_TYPE.CUSTOM){
    return (
      <>
        {colorInput.custom.map((item) => { return (<InputItem inputItem={item} disabled={disabled}/>)})}
      </>
    )
  }else if(type === LOGO_TYPE && selectedOption === LOGO_TYPE.IMAGE){
    return (
      <>
        {logoInput.image.map((item) => { return (
          <InputItem
            inputItem={item}
            setUploadedLogo={setUploadedLogo}
            hasRemovedLogo={hasRemovedLogo}
            preview={preview}
            setHasRemovedLogo={setHasRemovedLogo}
            setPreview={setPreview}
            disabled={disabled}
          />
        )})}
      </>
    )
  }else if(type === LOGO_TYPE && selectedOption === LOGO_TYPE.TEXTE){
    return (
      <>
        {logoInput.texte.map((item) => { return (<InputItem inputItem={item} disabled={disabled}/>)})}
      </>
    )
  }
}

const InputItem = ({inputItem, setUploadedLogo, preview, setPreview, setHasRemovedLogo, hasRemovedLogo, disabled}) => {
  switch (inputItem.type) {
    case PERSONALIZATION_INPUT_TYPE.TEXT:
      return <TextInput inputItem={inputItem} disabled={disabled}/>

    case PERSONALIZATION_INPUT_TYPE.SELECT:
      return <SelectInput inputItem={inputItem} disabled={disabled}/>

    case PERSONALIZATION_INPUT_TYPE.COLOR:
      return <ColorInput inputItem={inputItem} disabled={disabled}/>

    case PERSONALIZATION_INPUT_TYPE.LOGO:
      return  <LogoInput
        inputItem={inputItem}
        setUploadedLogo={setUploadedLogo}
        hasRemovedLogo={hasRemovedLogo}
        preview={preview}
        setHasRemovedLogo={setHasRemovedLogo}
        setPreview={setPreview}
        disabled={disabled}
      />

    case PERSONALIZATION_INPUT_TYPE.PALETTE:
      return  <PaletteInput inputItem={inputItem} disabled={disabled}/>

    default : return <></>;
  }
}

export default InputItemsSubSection;